module.exports = __webpack_public_path__ + "cae28770969a8c85ec3759023fb037cf.jpg";